import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    getSaldo(ctx, symbol) {
      return new Promise((resolve, reject) => {
        axios.get(`/usuario-info/saldo/${symbol}`)
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    converter(ctx, playload) {
      return new Promise((resolve, reject) => {
        axios.post('cambio/converter', playload)
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

  },
}
